import moment from "moment-timezone";
import SmsCalculator from "pages/SmsCalculator";
import React, { useState } from "react";
import { Col, Image } from "react-bootstrap";
import smsPic from "../../assets/img/mobileScreens/SMS.png";
import whatsappPic from "../../assets/img/mobileScreens/Whatsapp.png";
import rcsPic from "../../assets/img/mobileScreens/RCS.png";
import { RiFileExcel2Line, RiFileWord2Fill } from "react-icons/ri";
import { AiFillFilePdf } from "react-icons/ai";
import { PiArrowSquareUpRight, PiPhone } from "react-icons/pi";
import { MdOutlineContentCopy } from "react-icons/md";
import { GrDocumentText } from "react-icons/gr";
import { RCS_PROVIDERS } from "../../utils/constant";

const { KARIX, SMART_PING } = RCS_PROVIDERS;

export const MobilePreviews = ({
  currentChannel,
  content,
  onContentChange,
  smsHeader,
  waCategory,
  rcsProvider = KARIX,
}) => {
  //   console.log("ATpreview",   currentChannel,
  //       content)

  const date = moment();
  const currentTime = date.format("[Today], h:mm A");
  const WhatsappCurrentTime = date.format("h:mm A");

  // SMS content edit
  let contentData = content;

  const handleTextAreaChange = (event) => {
    const inputText = event.target.value;
    contentData = inputText;
    void onContentChange?.(inputText); // Notify parent
  };

  const [smsDetails, setSmsDetails] = useState({
    textLength: 0,
    remaining: 0,
    numberOfSMS: 1,
    encoding: "GSM 7",
  });
  const handleCalculation = ({
    textLength,
    remaining,
    numberOfSMS,
    encoding,
  }) => {
    setSmsDetails({ textLength, remaining, numberOfSMS, encoding });
  };

  if (currentChannel === "SMS") {
    return (
      <div>
        <SmsCalculator
          text={contentData || ""}
          onCalculation={handleCalculation}
        />
        <div className="img-cont">
          <img
            src={smsPic}
            alt="sms preview"
            aria-label="sms preview"
            title="sms preview"
          />
          <div className="preview-name mt-2">
            <span className="sender">{smsHeader}</span>
          </div>
          <div className="preview-cont" style={{marginTop:'15px'}}>
            <div className="time_box">
              <span>SMS</span>
              <span>{currentTime}</span>
            </div>
            <div className="d-flex flex-column position-relative">
              <>
                <textarea
                  rows={10}
                  id="smsBody"
                  name="template_content"
                  value={contentData}
                  onChange={handleTextAreaChange}
                  style={{
                    fontSize: "14px",
                    height: "250px",
                    padding: "8px",
                    resize: "none",
                    position: "relative",
                  }}
                />
                <p
                  className="chars_count"
                  style={{
                    position: "absolute",
                    bottom: "21%",
                    left: "51%",
                    fontSize: "10px",
                    textAlign: "center",
                  }}
                >
                  {contentData?.length || 0}
                </p>
              </>
              <div
                style={{
                  margin: "6px auto",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "space",
                  flexWrap: "wrap",
                  position: "relative",
                  width: "74%",
                  left: "-3%",
                }}
              >
                <div style={capsuleContainerStyle}>
                  <div style={capsuleStyle}>
                    <strong>{smsDetails.encoding}</strong>
                  </div>
                  <div style={capsuleStyle}>
                    <strong>Char Used: {smsDetails.textLength}</strong>
                  </div>
                  <div style={capsuleStyle}>
                    <strong>SMS Char: {smsDetails.remaining}</strong>
                  </div>
                  <div style={capsuleStyle}>
                    <strong>SMS Parts: {smsDetails.numberOfSMS}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (currentChannel === "WhatsApp") {
    return (
      <div>
        <div className="img-cont">
          <img
            src={whatsappPic}
            alt="whatsapp preview"
            title="whatsapp preview"
          />
          <div className="preview-cont" style={{marginTop:'15px'}}>
            {(contentData?.header ||
              contentData?.body ||
              contentData?.footer) &&
              waCategory !== "AUTHENTICATION" && (
                <div className="whatsBody">
                  {contentData?.header?.type === "text" && (
                    <span className="w-header">
                      {contentData?.header?.text}
                    </span>
                  )}
                  {contentData?.header?.type === "image" && (
                    <Image
                      src={contentData?.header?.image}
                      className="w-image"
                    />
                  )}
                  {contentData?.header?.type === "video" && (
                    <video controls width="100%" className="w-image">
                      <source
                        src={contentData?.header?.video}
                        type="video/mp4"
                      />
                      Unsupported video tag by browser.
                    </video>
                  )}
                  {contentData?.header?.type === "document" && (
                    <span className="w-doc">
                      {contentData?.header?.example ===
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                        <RiFileWord2Fill style={{ color: "#2A5293" }} />
                      ) : contentData?.header?.example === "application/pdf" ? (
                        <AiFillFilePdf style={{ color: "#CB3724" }} />
                      ) : contentData?.header?.example ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                        <RiFileExcel2Line style={{ color: "#4AA66A" }} />
                      ) : (
                        <GrDocumentText />
                      )}
                    </span>
                  )}
                  <span className="w-body">{contentData?.body?.text}</span>
                  <br />
                  {contentData?.footer && (
                    <span className="w-footer">
                      {contentData?.footer?.text}
                    </span>
                  )}
                  <div className="time_box">
                    <span className="ms-auto">{WhatsappCurrentTime}</span>
                  </div>

                  <div className="wdivider" />

                  {contentData.buttons &&
                    Object.keys(contentData.buttons).length > 0 && (
                      <div className="previewWhatsTemp">
                        <div className="wp-btns">
                          {contentData.buttons.type === "combined_buttons" &&
                            contentData.buttons.elements.map((row, index) => (
                              <p key={index}>
                                {row.type === "dynamic" ||
                                row.type === "static" ? (
                                  <>
                                    <PiArrowSquareUpRight />
                                    {row.text}
                                  </>
                                ) : row.type === "phone" ? (
                                  <>
                                    <PiPhone />
                                    {row.text}
                                  </>
                                ) : (
                                  row.text
                                )}
                              </p>
                            ))}
                          {contentData.buttons.type === "quick_reply" &&
                            contentData.buttons.elements.map((row, index) => (
                              <p key={index}>{row.text}</p>
                            ))}
                          {contentData.buttons.type === "call_to_action" &&
                            contentData.buttons.elements.map((row, index) => (
                              <p key={index}>
                                {row.type === "static" ||
                                row.type === "dynamic" ? (
                                  <>
                                    <PiArrowSquareUpRight />
                                    {row.text}
                                  </>
                                ) : (
                                  <>
                                    <PiPhone />
                                    {row.text}
                                  </>
                                )}
                              </p>
                            ))}
                        </div>
                      </div>
                    )}
                </div>
              )}
            {waCategory == "AUTHENTICATION" && (
              <div className="whatsBody">
                <span className="w-body">
                  <b>{contentData?.buttons?.text}</b> is your verification code.
                  For Your Security, do not share this code.
                </span>
                <br />
                {contentData.footer && (
                  <span className="w-footer">
                    This code expires in{" "}
                    {contentData?.footer?.code_expiration_minutes} minutes.
                  </span>
                )}
                {contentData.buttons && (
                  <>
                    <div className="wdivider" />
                    <div className="whatsButton">
                      <MdOutlineContentCopy /> Copy Code
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {contentData === null && (
            <div className="preview-cont">
              <p className="whatsBody text-danger">
                Sorry, no content preview available!
              </p>
            </div>
          )}
        </div>
      </div>
    );
  } else if (currentChannel === "RCS") {
    const rcsType = waCategory;
    const rcsTime = date.format("h:mm");

    const renderSmartPingSuggestions = (suggestions) => {
      if (!Array.isArray(suggestions) || suggestions.length === 0) return null;
      return (
        <div className="rcs-suggestions">
          {suggestions.map((suggestion, idx) => {
            if (Array.isArray(suggestion.buttons)) {
              return (
                <div key={idx} className="rcs-suggestion-row">
                  {suggestion.buttons.map((button, bidx) => (
                    <div key={bidx} className="whatsButton">
                      <span className="btn-txt">{button.text}</span>
                    </div>
                  ))}
                </div>
              );
            } else if (suggestion.text) {
              return (
                <div key={idx} className="whatsButton">
                  <span className="btn-txt">{suggestion.text}</span>
                </div>
              );
            }
            return null;
          })}
        </div>
      );
    };

    const renderKarixSuggestions = (suggestions) => {
      if (!Array.isArray(suggestions) || suggestions.length === 0) return null;
      return (
        <div className="rcs-suggestions">
          {suggestions.map((suggestion, idx) => (
            <div key={idx} className="whatsButton">
              <span className="btn-txt">
                {suggestion.text || suggestion.postbackData || ""}
              </span>
            </div>
          ))}
        </div>
      );
    };

    const renderSmartPingCarousel = (carouselCards) => {
      if (!Array.isArray(carouselCards) || carouselCards.length === 0)
        return null;
      return (
        <>
          <div className="whatsBody">
            <span className="w-body">Carousel Preview</span>
            <br />
            <div className="time_box">
              <span className="ms-auto">{rcsTime}</span>
            </div>
          </div>
          <div className="cards-container cards-slider">
            {carouselCards.map((card, idx) => (
              <div className="cardsBody" key={idx}>
                {card.media && card.media.fileType === "IMAGE" && (
                  <img
                    src={card.media.contentInfo.fileUrl}
                    alt="RCS Carousel"
                    className="w-image"
                    style={{
                      minWidth: "auto",
                      maxWidth: "-webkit-fill-available",
                    }}
                  />
                )}
                {card.media && card.media.fileType === "VIDEO" && (
                  <video
                    controls
                    className="w-image"
                    style={{ width: "100%", maxHeight: 180 }}
                  >
                    <source
                      src={card.media.contentInfo.fileUrl}
                      type="video/mp4"
                    />
                    Unsupported video tag by browser.
                  </video>
                )}
                <span className="w-header">{card.title}</span>
                <span className="w-body">{card.description}</span>
                <div className="wdivider" />
                {renderSmartPingSuggestions(card.suggestions)}
              </div>
            ))}
          </div>
        </>
      );
    };

    const renderKarixCarousel = (carouselCardArr) => {
      if (!Array.isArray(carouselCardArr) || carouselCardArr.length === 0)
        return null;
      return (
        <>
          <div className="whatsBody">
            <span className="w-body">Carousel Preview</span>
            <br />
            <div className="time_box">
              <span className="ms-auto">{rcsTime}</span>
            </div>
          </div>
          <div className="cards-container cards-slider">
            {carouselCardArr.map((card, idx) => (
              <div className="cardsBody" key={idx}>
                {card.mediaUrl && (
                  <img
                    src={card.mediaUrl}
                    alt="RCS Carousel"
                    className="w-image"
                    style={{
                      minWidth: "auto",
                      maxWidth: "-webkit-fill-available",
                    }}
                  />
                )}
                <span className="w-header">{card.cardTitle}</span>
                <span className="w-body">{card.cardDescription}</span>
                <div className="wdivider" />
                {renderKarixSuggestions(card.suggestions)}
              </div>
            ))}
          </div>
        </>
      );
    };

    const renderSmartPingRichCard = (contentData) => (
      <div className="whatsBody">
        {contentData?.imageUrl && contentData?.fileType === "IMAGE" && (
          <img
            src={contentData.imageUrl}
            alt="RCS Media"
            className="w-image"
            style={{
              minWidth: "auto",
              maxWidth: "-webkit-fill-available",
            }}
          />
        )}
        {contentData?.fileType && contentData?.fileType?.toLowerCase() === "video" && (
          <video
            controls
            className="w-image"
            style={{ width: "100%", maxHeight: 180 }}
            src={contentData.imageUrl}
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
        )}
        {contentData?.messageText && (
          <span className="w-header">{contentData.messageText}</span>
        )}
        {contentData?.messageDescription && (
          <span className="w-body">{contentData.messageDescription}</span>
        )}
        <br />
        <div className="time_box">
          <span className="ms-auto">{rcsTime}</span>
        </div>
        <div className="wdivider" />
        {renderSmartPingSuggestions(contentData?.suggestions)}
      </div>
    );

    const renderKarixRichCard = (standaloneCard) => (
      <div className="whatsBody">
        {standaloneCard?.mediaUrl && (
          <img
            src={standaloneCard.mediaUrl}
            alt="RCS Media"
            className="w-image"
            style={{
              minWidth: "auto",
              maxWidth: "-webkit-fill-available",
            }}
          />
        )}
        {standaloneCard?.cardTitle && (
          <span className="w-header">{standaloneCard.cardTitle}</span>
        )}
        {standaloneCard?.cardDescription && (
          <span className="w-body">{standaloneCard.cardDescription}</span>
        )}
        <br />
        <div className="time_box">
          <span className="ms-auto">{rcsTime}</span>
        </div>
        <div className="wdivider" />
        {renderKarixSuggestions(standaloneCard?.suggestions)}
      </div>
    );

    const renderKarixTextStandard = (data) => (
      <div className="whatsBody">
        {data?.textMessage && (
          <>
            <span className="w-body">{data.textMessage}</span>
            <div className="time_box">
              <span className="ms-auto">{rcsTime}</span>
            </div>
          </>
        )}
        <br />
        <div className="wdivider" />
        {renderKarixSuggestions(data?.suggestions)}
      </div>
    );

    const renderSmartPingTextStandard = (data) => (
      <div className="whatsBody">
        {data?.messageText && (
          <>
            <span className="w-body">{data.messageText}</span>
            <div className="time_box">
              <span className="ms-auto">{rcsTime}</span>
            </div>
          </>
        )}
        <br />
        <div className="wdivider" />
        {renderSmartPingSuggestions(data?.suggestions)}
      </div>
    );

    let previewContent = null;
    if (rcsProvider === SMART_PING) {
      if (["text_message", "standard"].includes(rcsType)) {
        previewContent = renderSmartPingTextStandard(contentData);
      } else if (rcsType === "carousel") {
        previewContent = renderSmartPingCarousel(contentData?.cardContents);
      } else if (rcsType === "rich_card") {
        previewContent = renderSmartPingRichCard(contentData);
      }
    } else {
      if (["text_message", "standard"].includes(rcsType)) {
        previewContent = renderKarixTextStandard(contentData);
      } else if (rcsType === "carousel") {
        previewContent = renderKarixCarousel(contentData?.carouselCard);
      } else if (rcsType === "rich_card") {
        previewContent = renderKarixRichCard(contentData?.standaloneCard);
      }
    }

    return (
      <div>
        <div className="img-cont">
          <img src={rcsPic} alt="rcs preview" title="rcs preview" />
          <div className="preview-cont">
            <div className="">{previewContent}</div>
          </div>
        </div>
      </div>
    );
  } else return null; // in case currentChannel is neither "SMS" nor "WhatsApp" nor "RCS"
};

const capsuleContainerStyle = {
  display: "flex",
  gap: "10px",
  justifyContent: "center",
  flexWrap: "wrap", // Allows wrapping on smaller screens
};

const capsuleStyle = {
  padding: "2px",
  backgroundColor: "#e0f7fa", // Light blue background
  borderRadius: "20px", // Rounded capsule effect
  border: "1px solid #00acc1", // Border color
  fontSize: "10px",
  color: "#006064", // Text color
  display: "flex",
  alignItems: "center",
  flex: "1 1 150px", // Sets minimum width and allows flexibility
  justifyContent: "center",
  textAlign: "center",
  maxWidth: "84px",
};
